"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ENDPOINTS_1 = __importDefault(require("../../../constants/app/ENDPOINTS"));
const http_service_1 = __importDefault(require("../../../services/http.service"));
// import getSessionToken from '../../../utils/login/getSessionToken';
/**
 * Client interface to validate Apple Pay session
 * @param {string} validationUrl
 * @returns {Promise}
 */
const validateSession = (validationUrl) => {
    const requestId = 'APPLE_PAY_VALIDATE_SESSION';
    // session token is mandatory
    // const sessionToken = getSessionToken();
    const config = {
        // headers: {
        //   Authorization: `Bearer ${sessionToken}`,
        // },
        data: {
            applePay: {
                validationUrl,
            },
        },
    };
    const endPoint = ENDPOINTS_1.default.BOOKING_SERVICE.APPLE_PAY_VALIDATE_SESSION;
    return http_service_1.default
        .post(requestId, endPoint, config)
        .then((response) => response.data);
};
exports.default = validateSession;
